import style from './subscribe.module.scss'
import { Form, Formik, FormikProps } from 'formik'
import { object as yupObject, string as yupString } from 'yup';
import { FormEvent, useState } from 'react';
import { sendSubscribe } from '@services/subscriptions.service';
import { emailToName } from '@libs/utils/email.utils';
import planeGIF from "/public/assets/icons/plane.gif"
import successIcon from "/public/assets/icons/success-icon.svg"
import Image from 'next/image';

const SubscribeBlock = () => {
  const [submitForm, setSubmit] = useState(false)


  const handleSubmit = async (formik: FormikProps<{ email: string }>, event: FormEvent) => {

    if (!formik.isValid) {
      event.preventDefault();
      formik.setFieldTouched('email');
      return;
    }

    try {
      const form = event.target as HTMLFormElement;
      form.EMAIL.value = formik.values.email;
      form.FNAME.value = emailToName(formik.values.email);
      await sendSubscribe(formik.values.email);
      setSubmit(true)
    } catch (e) {
      console.log('Error while subscribing to newsletter:', e);
    }

    setTimeout(() => {
      formik.resetForm();
    }, 0);
  }

  return (
    <div className={`${style.container__subscribe}`}>

      <div className={style.subscribe__info__wrap}>
        <div >
          <div className={style.subscribe__title}>
            Subscribe to our blog
          </div>
          <div>
            Enter your contact details to get the latest news.
          </div>
        </div>
        <div className={style.subscribe__img}>
            <div className={style.subscribe__img__gif}>
              <Image  src={planeGIF} alt='plane-icon' />
            </div>
        </div>
      </div>
            {!submitForm ?(
      <div className={style.subscribe__form__wrap}>
        <Formik
          initialValues={{ email: '' }}
          isInitialValid={false}
          validationSchema={yupObject({
            email: yupString()
              .required("Please enter your email address")
              .email('Please enter a valid email address'),
          })}
          onSubmit={async (values, actions) => {
          }}
        >
          {formik => (
            <Form className={style.subscribe__form}
              onSubmit={(e) => handleSubmit(formik, e)}
              action="//agilie.us15.list-manage.com/subscribe/post?u=51943de0f3ab2092fa65da481&amp;id=76b0cdbba6"
              method="post" target="_blank" noValidate
              >
              <div
                className={style.subscribe__block__item}>
                <input {...formik.getFieldProps('email')}
                  placeholder="Enter your email address" name="email"
                  className={`${style.subscribe__input} ${formik.touched.email && formik.errors.email ? style.subscribe__input_invalid : style.subscribe__input}`}
                  type="email" />
                <input type="hidden" name="EMAIL" tabIndex={-1} aria-hidden="true" />
                <input type="hidden" name="FNAME" tabIndex={-1} aria-hidden="true" />
                <input type="hidden" name="b_51943de0f3ab2092fa65da481_76b0cdbba6" tabIndex={-1}
                  aria-hidden="true" />

                <button className={style.subscribe__button}>Subscribe</button>
              </div>
              {
                formik.touched.email && formik.errors.email ?
                  <div
                    className={style.subscribe__form__wrap__invalidEmail}>{formik.errors.email}</div> : null
              }
            </Form>
          )}
        </Formik>
      </div>
            ) : (
              <div className={style.subscribe__success}>
              <Image className={style.subscribe__success__img} src={successIcon} alt='plane-icon' />
              <p className={style.subscribe__success__subtitle}>
                Success! Thank you for subscribing.
              </p>
              </div>
            )}
    </div>
  )
}

export default SubscribeBlock;
